import { Button, Modal as AntModal, Space } from 'antd'
import GoodsOrStyleSelect from './components/GoodsOrStyleSelect'
import { useEffect, useRef, useState } from 'react'
import SelectedBoard from '@/modules/distribute/components/SelectedBoard/index'
import styles from './index.less'

const DELAY_TIME = 800
export default ({ visible, onOk, onCancel, data, defaultValue = '', modalType, zIndex = 1000 }) => {
    const { modelTitle } = data
    const $fromErpRef = useRef(null)
    const $selectBoardRef = useRef(null)
    const [selected, setSelected] = useState([])
    const [selectedRows, setSelectedRows] = useState([])
    useEffect(() => {
        setTimeout(() => {
            // 弹框弹出时都要执行初始化
            visible && $selectBoardRef?.current?.textAreaChange(defaultValue)
        }, DELAY_TIME)
    }, [defaultValue, visible])

    const footer = (
        <Space size={15}>
            <Button onClick={onCancel}>取消</Button>
            <Button
                type="primary"
                onClick={() => {
                    onOk(selected.join(','))
                }}
            >
                确定
            </Button>
        </Space>
    )

    return (
        <AntModal
            title={modelTitle}
            width="1070px"
            visible={visible}
            maskClosable={false}
            destroyOnClose={true}
            footer={footer}
            onOk={onOk}
            onCancel={onCancel}
            zIndex={zIndex}
        >
            <div className={styles.container}>
                <GoodsOrStyleSelect
                    ref={$fromErpRef}
                    modalType={modalType}
                    textArea={
                        <SelectedBoard
                            ref={$selectBoardRef}
                            labelText={modalType === 'goods' ? '已选商品数' : '已选款式数'}
                            value={selected}
                            onChange={e => {
                                setSelected(e)
                            }}
                            placeholder={modelTitle}
                        />
                    }
                    selected={selected}
                    setSelected={setSelected}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                />
            </div>
        </AntModal>
    )
}
